module.exports = __webpack_public_path__ + "img/allegiant-flight-deck-logo.5cb2042c.svg";